// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 获取策略档案信息 GET /strategy/detail/info */
export async function strategyDetailInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyDetailInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyDetailInfoResp>('/strategy/detail/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取策略sku信息 GET /strategy/info */
export async function strategyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategySkuResp>('/strategy/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略通道列表 GET /strategy/passageway/list */
export async function strategyPassagewayListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyPassagewayListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPassagewayResp>('/strategy/passageway/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略收益详情 GET /strategy/profit/info */
export async function strategyProfitInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyProfitInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyProfitResp>('/strategy/profit/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略列表(白名单客户使用) GET /strategy/strategy/all/list */
export async function strategyStrategyAllListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyStrategyAllListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategyInfoResp>('/strategy/strategy/all/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略列表 GET /strategy/strategy/list */
export async function strategyStrategyListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyStrategyListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategyInfoResp>('/strategy/strategy/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 策略交易列表 GET /strategy/trade/list */
export async function strategyTradeListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.strategyTradeListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategyTradeResp>('/strategy/trade/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}
